module.exports = __webpack_public_path__ + "static/media/bd-receptionist-pc.c16f4da7.jpg";